import { inject, Pipe, PipeTransform } from "@angular/core";
import { FormValidationService } from "../../services/form-validation.service";
import { FactoryArg } from 'imask';

@Pipe({
  name: 'zipMask',
})
export class ZipCodeMaskPipe implements PipeTransform {
  private validationService = inject(FormValidationService);

  transform(country: string | null): FactoryArg {
    return this.validationService.zipCodeMask(country);
  }
}
